import { useAuth } from "@/contexts/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AppShell from "@/components/AppShell";
import AdvisorSidebar from "@/components/AdvisorSidebar";
import { ADMIN_ROLES } from "@/lib/roles";

/**
 * App shell for BL advisor pages: the shared sidebar layout. Admins (who can
 * also reach advisor routes) keep the plain navigation + content + footer
 * layout, mirroring how BuyerShell handles admins.
 */
export default function AdvisorShell({ children }: { children: React.ReactNode }) {
  const { hasRole } = useAuth();
  const showSidebar = hasRole("bl_advisor") && !hasRole(...ADMIN_ROLES);

  if (!showSidebar) {
    return (
      <>
        <Navigation />
        {children}
        <Footer />
      </>
    );
  }

  return <AppShell sidebar={<AdvisorSidebar />}>{children}</AppShell>;
}
